/**
 * Create Domain Command
 * 
 * Command for creating new DDD Domain strategic models.
 * Includes validation and business rule enforcement.
 */

import { ICommand, BaseCommand } from '@swoft/core';

export interface CreateDomainPayload {
  name: string;
  description?: string;
  vision?: string;
  ubiquitousLanguage?: Record<string, string>;
}

export class CreateDomainCommand extends BaseCommand implements ICommand {
  constructor(
    public readonly payload: CreateDomainPayload,
    authSessionId: string,
    initiatedByPersonId: string,
    correlationId?: string
  ) {
    super(authSessionId, initiatedByPersonId, correlationId);
  }
}